jQuery.fn.init = (function(oldInit) {
	return function(selector, context) {
		return (new oldInit(selector, context)).data('selector', selector);
	};
})(jQuery.fn.init);